import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] grid place-items-center px-6 pt-32">
      <div className="text-center max-w-md">
        <p className="label-caps text-muted-foreground">404</p>
        <h1 className="font-serif-display text-4xl mt-4">Page not found</h1>
        <p className="text-muted-foreground mt-4">The page you requested does not exist or has moved.</p>
        <Link to="/" className="inline-block mt-8 rounded-full bg-primary text-primary-foreground px-6 py-3 font-medium">
          Back to home
        </Link>
      </div>
    </div>
  );
}
